import { useId } from 'react';

import { MAX_JITTER_MS, MIN_JITTER_MS } from '../audio/jitter';

export function VolumeControls({
  volume,
  muted,
  onVolume,
  onMuted,
}: {
  volume: number;
  muted: boolean;
  onVolume(value: number): void;
  onMuted(value: boolean): void;
}) {
  const id = useId();
  const percent = Math.round(volume * 100);

  return (
    <div className="mix">
      <button
        type="button"
        className="btn btn-icon"
        onClick={() => onMuted(!muted)}
        aria-pressed={muted}
        title={muted ? 'Unmute' : 'Mute'}
      >
        <span aria-hidden="true">{muted ? '🔇' : '🔊'}</span>
        <span className="visually-hidden">{muted ? 'Unmute' : 'Mute'}</span>
      </button>
      <label htmlFor={id}>Volume</label>
      <input
        id={id}
        type="range"
        min={0}
        max={100}
        step={1}
        value={percent}
        onChange={(event) => onVolume(Number(event.target.value) / 100)}
        aria-valuetext={`${percent} percent`}
        style={{ flex: '1 1 8rem' }}
      />
    </div>
  );
}

export function BufferSlider({
  targetMs,
  measuredMs,
  onChange,
}: {
  targetMs: number;
  measuredMs: number;
  onChange(value: number): void;
}) {
  const id = useId();
  const hintId = `${id}-hint`;

  return (
    <div className="slider-row">
      <div className="slider-head">
        <label htmlFor={id}>Latency buffer</label>
        <strong>
          {targetMs} ms target · {Math.round(measuredMs)} ms buffered
        </strong>
      </div>
      <input
        id={id}
        type="range"
        min={MIN_JITTER_MS}
        max={MAX_JITTER_MS}
        step={10}
        value={targetMs}
        onChange={(event) => onChange(Number(event.target.value))}
        aria-describedby={hintId}
        aria-valuetext={`${targetMs} milliseconds`}
      />
      <p className="hint" id={hintId}>
        Lower is more immediate; higher survives a worse connection. Changes apply straight away.
      </p>
    </div>
  );
}
